export default __webpack_public_path__ + "static/media/userIcon.63d1e4e6.png";